<div class="group dashboard-layout flex h-screen overflow-hidden bg-page" [class.sidebar-collapsed]="sidebarCollapsed()">
  <!-- Mobile overlay -->
  @if (!sidebarCollapsed()) {
    <div class="fixed inset-0 z-40 hidden bg-overlay backdrop-blur-[2px] max-[1024px]:block" (click)="toggleSidebar()"></div>
  }

  <aside
    class="fixed top-0 left-0 z-50 flex h-screen w-63 shrink-0 flex-col overflow-hidden border-r border-border bg-card text-fg-secondary shadow-sm transition-transform duration-200 ease-in-out max-[1024px]:translate-x-0 max-[1024px]:group-[.sidebar-collapsed]:-translate-x-full"
  >
    <div class="relative flex shrink-0 items-center justify-start border-b border-border px-4 py-4.5">
      <a routerLink="/" class="flex w-full items-center gap-2.5 text-fg no-underline">
        <img src="main_money_square.png" alt="MainMoney" class="size-9 rounded-[0.55rem] object-contain" />
        <div class="flex flex-col gap-0.5">
          <span class="text-[1.02rem] leading-[1.1] font-bold text-fg">MainMoney</span>
          <span class="text-[0.72rem] tracking-[0.04em] text-fg-secondary uppercase">Aggregator</span>
        </div>
      </a>
      <button
        type="button"
        class="absolute top-1/2 right-4 hidden -translate-y-1/2 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent p-2 text-fg-secondary hover:bg-row-hover hover:text-fg max-[1024px]:flex"
        (click)="toggleSidebar()"
        aria-label="Close menu"
      >
        <ng-icon name="lucideX" size="20" />
      </button>
    </div>

    <nav class="min-h-0 flex-1 overflow-y-auto pt-3.5 pb-4">
      <p class="mx-3.5 mt-0 mb-1.5 px-1.5 text-[0.64rem] font-bold tracking-[0.08em] text-fg-secondary/75 uppercase" i18n="@@nav.sectionHome">Home</p>
      <a
        routerLink="/app"
        routerLinkActive="bg-primary/15 text-primary"
        [routerLinkActiveOptions]="{ exact: true }"
        class="nav-item nav-link mx-2.5 my-0.5 flex items-center gap-3 rounded-[0.72rem] px-3.5 py-2.5 text-[0.9rem] font-semibold text-fg-secondary no-underline transition-colors hover:bg-row-hover hover:text-fg"
      >
        <ng-icon name="lucideHouse" size="20" />
        <span i18n="@@nav.dashboard">Dashboard</span>
      </a>

      <p class="mx-3.5 mt-3 mb-1.5 px-1.5 text-[0.64rem] font-bold tracking-[0.08em] text-fg-secondary/75 uppercase" i18n="@@nav.sectionManagement">Management</p>
      @for (group of roleAccess.menuGroups(); track group.key) {
        <div class="my-0.5" [class.expanded]="isExpanded(group)">
          <button
            type="button"
            class="mx-2.5 my-0.5 flex w-[calc(100%-1.4rem)] cursor-pointer items-center gap-3 rounded-[0.72rem] border-0 px-3.5 py-2.5 text-left text-[0.9rem] font-semibold transition-colors"
            [class]="isExpanded(group) ? 'bg-primary/15 text-primary' : 'bg-transparent text-fg-secondary hover:bg-row-hover hover:text-fg'"
            (click)="toggleGroup(group)"
          >
            <ng-icon [name]="group.icon" size="18" />
            <span class="flex-1">{{ group.label }}</span>
            <ng-icon [name]="isExpanded(group) ? 'lucideChevronDown' : 'lucideChevronRight'" size="14" [class]="isExpanded(group) ? 'opacity-85' : 'opacity-55'" />
          </button>
          @if (isExpanded(group)) {
            <div class="pt-1 pb-2 transition duration-150 starting:-translate-y-1 starting:opacity-0">
              @for (item of group.items; track item.key) {
                <a
                  [routerLink]="shellRoutes.commands('manage', item.key)"
                  routerLinkActive="bg-primary/15 text-primary font-semibold!"
                  class="mx-2.5 my-0.5 block rounded-[0.72rem] py-2.5 pr-3.5 pl-10.5 text-[0.85rem] font-normal text-fg-secondary no-underline transition-colors hover:bg-row-hover hover:text-fg"
                >
                  {{ item.label }}
                </a>
              }
            </div>
          }
        </div>
      }
    </nav>

    <div class="shrink-0 border-t border-border bg-card px-3.5 pt-3 pb-4">
      <a
        routerLink="/api-docs"
        target="_blank"
        rel="noopener"
        class="mb-2.5 flex flex-col gap-0.5 rounded-[0.72rem] border border-border bg-row-hover px-3 py-2.5 no-underline"
      >
        <span class="text-[0.72rem] text-fg-secondary">Need help?</span>
        <span class="text-[0.84rem] font-bold text-primary">Documentation</span>
      </a>
      <button
        type="button"
        class="flex w-full cursor-pointer items-center gap-3 rounded-[0.72rem] border-0 bg-transparent px-3.5 py-2.5 text-[0.9375rem] font-medium text-fg-secondary transition-colors hover:bg-danger-bg hover:text-danger-fg"
        (click)="handleLogout()"
      >
        <ng-icon name="lucideLogOut" size="20" class="shrink-0" />
        <span i18n="@@nav.signOutSidebar">Sign out</span>
      </button>
    </div>
  </aside>

  <div class="main ml-63 flex h-screen min-w-0 flex-1 flex-col overflow-hidden bg-page max-[1024px]:ml-0">
    <header class="sticky top-0 z-30 flex min-h-17.5 shrink-0 items-center justify-between gap-4 border-b border-border bg-card pr-5 pl-4.5">
      <div class="flex min-w-0 items-center gap-3.5">
        <button
          type="button"
          class="hidden cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent p-2.5 text-fg-secondary hover:bg-row-hover hover:text-primary max-[1024px]:flex"
          (click)="toggleSidebar()"
          aria-label="Open menu"
        >
          <ng-icon name="lucideMenu" size="22" />
        </button>
        <div class="flex min-w-0 flex-col max-[1024px]:hidden">
          <span class="text-base leading-tight font-bold text-fg">Dashboard Overview</span>
          <span class="text-[0.72rem] tracking-[0.06em] whitespace-nowrap text-fg-secondary uppercase">{{ roleSwitchLabel() }}</span>
        </div>
        <div
          class="search-dropdown-container relative flex min-w-70 items-center gap-2 rounded-full border border-border bg-card px-3 py-2 text-[0.84rem] text-fg-secondary max-[1024px]:hidden"
        >
          <ng-icon name="lucideSearch" size="16" />
          <input
            type="text"
            class="w-80 border-0 bg-transparent text-[0.84rem] text-fg outline-none placeholder:text-muted"
            placeholder="Search pages, entities, transactions..."
            [value]="searchTerm()"
            (focus)="searchDropdownOpen.set(searchTerm().trim().length > 0)"
            (input)="onSearchChange($any($event.target).value)"
          />
          @if (searchDropdownOpen()) {
            <div [class]="menuClass + ' right-auto left-0 min-w-105'">
              @if (searchResults().length === 0 && searchTerm().trim().length >= 2) {
                <div class="px-4 py-3 text-[0.85rem] text-fg-secondary">No results</div>
              }
              @for (result of searchResults(); track result.route) {
                <button type="button" [class]="itemClass" (click)="openSearchResult(result)">
                  <span class="min-w-10 text-[0.72rem] text-fg-secondary uppercase">{{ result.type }}</span>
                  <span>{{ result.label }}</span>
                </button>
              }
            </div>
          }
        </div>
      </div>

      <div class="ml-auto flex items-center gap-2">
        <ui-theme-toggle />

        <div class="language-dropdown-container relative max-[1024px]:hidden">
          <button type="button" [class]="iconBtnClass" aria-label="Language" (click)="toggleLanguageDropdown()">
            <ng-icon name="lucideLanguages" size="17" />
          </button>
          @if (languageDropdownOpen()) {
            <div [class]="menuClass + ' min-w-40'">
              @for (language of availableLanguages; track language.code) {
                <button type="button" [class]="itemClass" (click)="selectLanguage(language.code)">
                  <span>{{ language.label }}</span>
                  @if (isLanguageSelected(language.code)) {
                    <ng-icon name="lucideCheck" size="16" />
                  }
                </button>
              }
            </div>
          }
        </div>

        <div class="notification-dropdown-container relative max-[1024px]:hidden">
          <button type="button" [class]="iconBtnClass + ' relative'" aria-label="Notifications" (click)="toggleNotificationDropdown()">
            <ng-icon name="lucideBell" size="17" />
            @if (unreadNotificationCount() > 0) {
              <span
                class="absolute -top-0.75 -right-0.75 inline-flex h-4.25 min-w-4.25 items-center justify-center rounded-full bg-brand px-0.75 text-[0.65rem] font-bold text-white"
                >{{ unreadNotificationCount() }}</span
              >
            }
          </button>
          @if (notificationDropdownOpen()) {
            <div [class]="menuClass + ' max-h-105 min-w-85 overflow-y-auto'">
              <div class="flex items-center justify-between bg-surface-muted p-4">
                <span>Notifications</span>
                <button type="button" class="cursor-pointer border-0 bg-transparent text-xs font-semibold text-primary" (click)="markAllNotificationsAsRead()">Mark all read</button>
              </div>
              @if (notifications().length === 0) {
                <div class="px-4 py-3 text-[0.85rem] text-fg-secondary">No notifications</div>
              }
              @for (notification of notifications(); track notification.id) {
                <button
                  type="button"
                  [class]="itemClass + ' flex-col items-start gap-0.5 ' + (notification.is_read ? 'opacity-70' : '')"
                  (click)="markNotificationAsRead(notification)"
                >
                  <span class="font-bold text-fg">{{ notification.title }}</span>
                  <span class="text-[0.8rem] text-fg-secondary">{{ notification.message }}</span>
                </button>
              }
            </div>
          }
        </div>

        <div class="role-dropdown-container relative max-[1024px]:hidden">
          <button
            type="button"
            class="flex max-w-75 cursor-pointer items-center gap-2 rounded-full border border-border bg-card px-2.5 py-1.5 text-fg"
            (click)="toggleRoleDropdown()"
          >
            @if (auth.user()?.active_assignment?.merchant_logo) {
              <img
                [src]="auth.user()?.active_assignment?.merchant_logo!"
                alt="merchant logo"
                class="size-4.5 rounded-sm object-contain"
              />
            } @else {
              <ng-icon name="lucideStore" size="16" />
            }
            <span class="max-w-52 truncate text-[0.8rem] text-fg-secondary">{{ roleSwitchLabel() }}</span>
            <ng-icon [name]="roleDropdownOpen() ? 'lucideChevronDown' : 'lucideChevronRight'" size="14" class="text-fg-secondary opacity-85" />
          </button>
          @if (roleDropdownOpen()) {
            <div [class]="menuClass + ' min-w-80'">
              @for (assignment of roleAssignments(); track assignment.user_role_id) {
                <button
                  type="button"
                  [class]="itemClass + (isActiveAssignment(assignment) ? ' bg-surface-muted' : '')"
                  (click)="switchAssignment(assignment)"
                >
                  <span>
                    {{ assignment.role_code }}
                    @if (assignment.merchant_name) {
                      - {{ assignment.merchant_name }}
                    }
                  </span>
                </button>
              }
            </div>
          }
        </div>

        <!-- User Dropdown -->
        <div class="user-dropdown-container relative">
          <button
            type="button"
            class="flex cursor-pointer items-center gap-2 rounded-full border border-border bg-card px-2.5 py-1.5 transition-colors hover:border-primary/35 hover:bg-row-hover max-[1024px]:p-1.5"
            (click)="toggleUserDropdown()"
          >
            <div class="flex size-7.5 items-center justify-center rounded-full bg-linear-to-br from-primary to-brand text-white">
              <ng-icon name="lucideUser" size="18" />
            </div>
            <span class="max-w-27.5 truncate text-[0.8rem] font-semibold text-fg-secondary max-[1024px]:hidden">{{ auth.user()?.first_name ?? auth.user()?.username ?? 'User' }}</span>
            <ng-icon [name]="userDropdownOpen() ? 'lucideChevronDown' : 'lucideChevronRight'" size="14" class="text-fg-secondary opacity-85 max-[1024px]:hidden" />
          </button>

          @if (userDropdownOpen()) {
            <div [class]="menuClass">
              <div class="bg-surface-muted p-4">
                <div class="flex flex-col gap-0.5">
                  <span class="text-base font-bold text-fg">{{ auth.user()?.first_name ?? auth.user()?.username ?? 'User' }}</span>
                  <span class="text-sm text-fg-secondary">{{ auth.user()?.email ?? '' }}</span>
                  <span class="text-sm text-fg-secondary">Language: {{ selectedLanguage().toUpperCase() }}</span>
                </div>
              </div>
              <div class="h-px bg-border"></div>
              <a [href]="documentationUrl" target="_blank" rel="noopener" [class]="itemClass">
                <ng-icon name="lucideFileText" size="16" />
                <span i18n="@@user.documentation">Documentation</span>
              </a>
              @if (roleAccess.canViewInternalDocs()) {
                <a [href]="internalDocumentationUrl" target="_blank" rel="noopener" [class]="itemClass">
                  <ng-icon name="lucideFileText" size="16" />
                  <span i18n="@@user.internalDocumentation">Internal Documentation</span>
                </a>
              }
              @if (roleAccess.effectiveRole() === 'SYSTEM_ADMIN') {
                <a [href]="adminUrl" target="_blank" rel="noopener" [class]="itemClass">
                  <ng-icon name="lucideWrench" size="16" />
                  <span i18n="@@user.admin">Admin</span>
                </a>
              }
              <a routerLink="/app/settings" [class]="itemClass" (click)="userDropdownOpen.set(false)">
                <ng-icon name="lucideKey" size="16" />
                <span i18n="@@user.changePassword">Change Password</span>
              </a>
              <div class="h-px bg-border"></div>
              <button type="button" [class]="itemClass + ' text-danger! hover:bg-danger-bg! [&_ng-icon]:text-danger!'" (click)="handleLogout()">
                <ng-icon name="lucideLogOut" size="16" />
                <span i18n="@@user.signOut">Sign Out</span>
              </button>
            </div>
          }
        </div>
      </div>
    </header>

    <main class="flex-1 overflow-x-hidden overflow-y-auto p-8 max-[1024px]:p-4">
      <router-outlet />
    </main>
  </div>
</div>
<app-session-idle-modal />
